export default __webpack_public_path__ + "static/media/lake.f576c5b5.ogg";